import React, { useState } from "react";
import PageHeader from "../components/ui/PageHeader";
import SalesInvoiceList from "../components/sales/SalesInvoiceList";
import SalesInvoiceForm from "../components/sales/SalesInvoiceForm";
import SalesInvoiceDetail from "../components/sales/SalesInvoiceDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const SalesInvoicesPage = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);

  const handleView = (invoice) => {
    navigate(`/sales/${invoice.id}`);
  };

  const handleEdit = (invoice) => {
    setEditingInvoice(invoice);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingInvoice(null);
    setRefreshKey((k) => k + 1);
  };

  if (invoiceId) {
    return <SalesInvoiceDetail invoiceId={invoiceId} onEdit={handleEdit} />;
  }

  return (
    <Box>

     <Box
      sx={{
        backgroundColor: "#ffebee",
        border: "2px solid #d32f2f",
        borderRadius: "12px",
        padding: "16px 24px",
        marginBottom: "24px",
        textAlign: "center",
      }}
    >
      <Box
        component="span"
        sx={{
          color: "#d32f2f",
          fontWeight: 800,
          fontSize: { xs: "1rem", sm: "1.3rem", md: "1.6rem" },
          letterSpacing: "0.5px",
          textTransform: "uppercase",
          display: "block",
          lineHeight: 1.4,
        }}
      >
        ⚠️ NO CREES FACTURAS AQUÍ A NO SER QUE HAYAS RECIBIDO UN PAGO QUE NO TENGA FACTURA ⚠️
      </Box>
    </Box>
      <PageHeader
        title="Ventas / Ingresos"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingInvoice(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              "&:hover": {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: "brightness(1.05)",
              },
            }}
          >
            Nueva Factura de Venta
          </Button>
        }
      />
      <SalesInvoiceList
        key={refreshKey}
        onView={handleView}
        onEdit={handleEdit}
      />

      <Dialog
        key={editingInvoice?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingInvoice(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <SalesInvoiceForm
            invoice={editingInvoice}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingInvoice(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SalesInvoicesPage;
